import { render, staticRenderFns } from "./ChatBubble.vue?vue&type=template&id=26795e8e&scoped=true"
import script from "./ChatBubble.vue?vue&type=script&lang=js"
export * from "./ChatBubble.vue?vue&type=script&lang=js"
import style0 from "./ChatBubble.vue?vue&type=style&index=0&id=26795e8e&prod&scoped=true&lang=css"
import style1 from "./ChatBubble.vue?vue&type=style&index=1&id=26795e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26795e8e",
  null
  
)

export default component.exports